import { formatLocalizedDate } from '@munifocus/utils';

/**
 * A date on the triage queue and a citizen report's detail, in the officer's
 * language. French reads the first of the month as an ordinal — "1er nov.",
 * not "1 nov." — which `Intl` does not do; `formatLocalizedDate` does.
 */
export function formatTriageDate(
  iso: string,
  language: string,
  options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' },
): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return formatLocalizedDate(date, language, options);
}
